var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-post loading"},[_c('div',{staticClass:"map-post__slider"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"loading-line-1"}),_vm._v(" "),_c('div',{staticClass:"loading-line-2"}),_vm._v(" "),_c('div',{staticClass:"loading-line-3"})])])
}]

export { render, staticRenderFns }